import React, { useState, useEffect } from "react";
import {
  Table,
  Typography,
  Button,
  Input,
  Space,
  Modal,
  Form,
  InputNumber,
  Select,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next"; // ✅ add i18n
import { companyService } from "../../app/services";

const { Title, Text } = Typography;
const { Option } = Select;

const CompanyServicesPage = ({ profile }) => {
  const [services, setServices] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [form] = Form.useForm();
  const { t } = useTranslation(); // ✅ translation hook

  useEffect(() => {
    fetchServices();
    fetchServiceType();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await companyService.getCompanyServicesByParameter(
        profile?.username,
        null,
        null
      );
      if (response && Array.isArray(response)) {
        setServices(response);
      }
    } catch (err) {
      console.error(err);
      message.error(t("CompanyServicesPage.load_services_fail"));
    }
  };

  const fetchServiceType = async () => {
    try {
      const response = await companyService.getCompanyServicesByParameter(
        "",
        "",
        profile.companyCategoryName
      );
      if (response && Array.isArray(response)) {
        setServiceType(response);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddEdit = async (values) => {
    try {
      const selectedServicetype = serviceType.find(
        (c) => c.name === values.serviceTypeId
      );
      if (!selectedServicetype) {
        message.error(t("CompanyServicesPage.select_service_error"));
        return;
      }

      const payload = {
        ...values,
        id: editingService?.id,
        name: selectedServicetype.name,
        icon: selectedServicetype.icon,
      };

      if (editingService) {
        const oldService = editingService;
        const newService = {
          id: editingService.id,
          companyId: profile.username,
          serviceTypeId: selectedServicetype.id,
          price: values.price,
          currency: values.currency,
          duration: values.duration,
        };

        await companyService.updateCompanyService(
          profile.username,
          oldService,
          newService
        );

        message.success(t("CompanyServicesPage.update_success"));
      } else {
        await companyService.addCompanyService(profile.username, payload);
        message.success(t("CompanyServicesPage.add_success"));
      }

      fetchServices();
      setIsModalOpen(false);
      setEditingService(null);
      form.resetFields();
    } catch (err) {
      console.error(err);
      message.error(t("CompanyServicesPage.save_fail"));
    }
  };

  const handleEditClick = (record) => {
    setEditingService(record);

  const selected = serviceType.find((s) => s.name === record.name);

    form.setFieldsValue({
      serviceTypeId: selected?.id,
      duration: record.duration,
      price: record.price,
      currency: record.currency,
    });

    setIsModalOpen(true);
  };

  const columns = [
    {
      title: t("CompanyServicesPage.service"),
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space>
          {record.icon && (
            <span
              dangerouslySetInnerHTML={{ __html: record.icon }}
              style={{
                width: 20,
                height: 20,
                display: "inline-block",
                lineHeight: 0,
              }}
            />
          )}
          <Text strong>{t(`${text}`)}</Text>
        </Space>
      ),
    },
    {
      title: t("CompanyServicesPage.duration"),
      dataIndex: "duration",
      key: "duration",
      render: (val) => `${val} ${t("CompanyServicesPage.minutes")}`,
    },
    {
      title: t("CompanyServicesPage.price"),
      dataIndex: "price",
      key: "price",
      render: (val, record) => `${val} ${record.currency}`,
    },
    {
      title: t("CompanyServicesPage.action"),
      key: "action",
      render: (_, record) => (
        <Button type="link" onClick={() => handleEditClick(record)}>
          {t("CompanyServicesPage.edit")}
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Title level={3} style={{ marginBottom: 24 }}>
        {t("CompanyServicesPage.title")}
      </Title>

      <Space style={{ marginBottom: 16, width: "100%" }} align="center">
        <Input.Search
          placeholder={t("CompanyServicesPage.search_placeholder")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ maxWidth: 300 }}
        />
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setIsModalOpen(true)}
        >
          {t("CompanyServicesPage.add_service")}
        </Button>
      </Space>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={services.filter((s) =>
          s.name.toLowerCase().includes(search.toLowerCase())
        )}
        pagination={false}
        bordered={false}
        style={{
          background: "white",
          borderRadius: 8,
          boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
        }}
      />

      {/* Modal Add/Edit Service */}
      <Modal
        title={
          editingService
            ? t("CompanyServicesPage.edit_service")
            : t("CompanyServicesPage.add_service")
        }
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setEditingService(null);
          form.resetFields();
        }}
        footer={null}
        width={600}
      >
        <Form layout="vertical" form={form} onFinish={handleAddEdit}>
          {/* <Form.Item
            name="serviceTypeId"
            label={t("CompanyServicesPage.choose_from_catalog")}
            rules={[
              { required: true, message: t("CompanyServicesPage.choose_required") },
            ]}
          >
            <Select
              placeholder={t("CompanyServicesPage.select_placeholder")}
              optionLabelProp="label"
              onChange={(id) => {
                const selected = serviceType.find((s) => s.id === id);
                if (selected) {
                  form.setFieldsValue({
                    duration: selected.defaultDuration || 30,
                    price: selected.defaultPrice || 0,
                    currency: "EUR",
                  });
                }
              }}
            >
              {serviceType.map((s) => (
                <Option key={s.id} value={s.id} label={t(s.name)}>
                  <Space>
                    {s.icon && (
                      <span
                        dangerouslySetInnerHTML={{ __html: s.icon }}
                        style={{
                          width: 20,
                          height: 20,
                          display: "inline-block",
                          lineHeight: 0,
                        }}
                      />
                    )}
                       {t(s.name)}
                  </Space>
                </Option>
              ))}
            </Select>
          </Form.Item> */}
          <Form.Item
  name="serviceTypeId"
  label={t("CompanyServicesPage.choose_from_catalog")}
  rules={[
    { required: true, message: t("CompanyServicesPage.choose_required") },
  ]}
>
  <Select
    placeholder={t("CompanyServicesPage.select_placeholder")}
    optionLabelProp="label"
    onChange={(id) => {
      const selected = serviceType.find((s) => s.id === id);
      if (selected) {
        form.setFieldsValue({
          duration: selected.defaultDuration || 30,
          price: selected.defaultPrice || 0,
          currency: "EUR",
        });
      }
    }}
  >
    {serviceType.map((s) => (
      <Option key={s.id} value={s.id} label={t(s.name)}>
        <Space>
          {s.icon && (
            <span
              dangerouslySetInnerHTML={{ __html: s.icon }}
              style={{
                width: 20,
                height: 20,
                display: "inline-block",
                lineHeight: 0,
              }}
            />
          )}
          {t(s.name)}
        </Space>
      </Option>
    ))}
  </Select>
</Form.Item>


          <Form.Item
            name="duration"
            label={t("CompanyServicesPage.duration_label")}
            rules={[{ required: true, message: t("CompanyServicesPage.duration_required") }]}
          >
            <InputNumber min={5} max={480} style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            name="price"
            label={t("CompanyServicesPage.price_label")}
            rules={[{ required: true, message: t("CompanyServicesPage.price_required") }]}
          >
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            name="currency"
            label={t("CompanyServicesPage.currency")}
            initialValue="EUR"
            rules={[{ required: true, message: t("CompanyServicesPage.currency_required") }]}
          >
            <Select>
              <Option value="CHF">CHF</Option>
              <Option value="EUR">EUR</Option>
              <Option value="USD">USD</Option>
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {editingService ? t("CompanyServicesPage.update") : t("CompanyServicesPage.add")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default CompanyServicesPage;
